import Color from "../common/ColorEnum";
import ROUTE from "../common/Routes";
import { checkStatusExpiry } from "../common/checkStatusExpiry";
import moment from "moment";
import api from "./configAxios";
import Controller from "../common/controller";

export const getTreeData1API = async (dynamoDBClient, sortType) => {
  try {
    const result = [
      {
        id: "All",
        name: "All",
        navigate: ROUTE.Home,
        navigateTo: 0,
        color: "none",
      },
    ];
    const AccountInfo = [];
    const queryParams = {
      TableName: "Users",
      FilterExpression: "RoleId = :roleIdValue",
      ExpressionAttributeValues: {
        ":roleIdValue": "3",
      },
      ProjectionExpression:
        "Email , FirstName , LastName, DateSubmitted, RoleId",
    };
    const data = await dynamoDBClient.scan(queryParams).promise();

    await Promise.all(
      data.Items.map((info) => {
        AccountInfo.push({
          id: info?.Email,
          email: info?.Email,
          name: info?.FirstName
            ? `${info?.FirstName}${info?.LastName}`
            : `${info?.Email.split("@")[0]}`,
          navigate: ROUTE.Account,
          date: moment
            .utc(info.DateSubmitted, "YYYY-MM-DD HH:mm:ss Z")
            .format("MM/DD/YYYY  h:mm:ss a"),
          color: "none",
          limit: 19,
          navigateTo: 1,
        });

        return "";
      })
    );

    if (sortType === "a-z") {
      AccountInfo.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    }
    if (sortType === "z-a") {
      AccountInfo.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return 1;
        }
        if (nameA > nameB) {
          return -1;
        }
        return 0;
      });
    }
    if (sortType === "dateDesc") {
      AccountInfo.sort((a, b) => {
        const dateA = moment(a.date, "MM/DD/YYYY hh:mm:ss a");
        const dateB = moment(b.date, "MM/DD/YYYY hh:mm:ss a");
        return dateA - dateB;
      });
    }
    if (sortType === "dateAsc") {
      AccountInfo.sort((a, b) => {
        const dateA = moment(a.date, "MM/DD/YYYY hh:mm:ss a");
        const dateB = moment(b.date, "MM/DD/YYYY hh:mm:ss a");
        return dateB - dateA;
      });
    }

    result[0].children = AccountInfo;

    return result;
  } catch (error) {
    throw new Error(error);
  }
};

export const getTreeData2API = async (dynamoDBClient, data = []) => {
  try {
    let accountinfo = [];
    const record = data[0].children;
    let results = data;
    if (record.length > 0) {
      accountinfo = record;

      if (accountinfo.length > 0) {
        const param1 = {
          TableName: "GatewayData",
          ProjectionExpression: "Email, GatewayMAC, DateUpdated",
        };
        const param2 = {
          TableName: "Gateways",
          ProjectionExpression:
            "Email, GatewayMAC, DeviceName, GatewayLocation, Firmware",
        };
        const param3 = {
          TableName: "GatewayUser",
          ProjectionExpression: "Email, GatewayMAC",
        };
        const baseStationData1 = await dynamoDBClient.scan(param1).promise();
        const baseStationData2 = await dynamoDBClient.scan(param2).promise();
        const baseStationData3 = await dynamoDBClient.scan(param3).promise();
        const data1 = baseStationData1.Items;
        const data2 = baseStationData2.Items;
        const data3 = baseStationData3.Items;
        await Promise.all(
          accountinfo.map((account, index) => {
            const result = [];
            data3.forEach((item) => {
              let status = "offline";

              data2.forEach((record) => {
                if (
                  item.GatewayMAC === record.GatewayMAC &&
                  item.Email === account.email &&
                  record.Email === account.email
                ) {
                  data1.forEach((activeGateway) => {
                    if (
                      activeGateway.GatewayMAC === item.GatewayMAC &&
                      activeGateway.Email === item.Email
                    ) {
                      const isGreaterTime = checkStatusExpiry(
                        activeGateway.DateUpdated
                      );
                      if (isGreaterTime) {
                        status = "offline";
                      } else {
                        status = "online";
                      }
                    }
                  });
                  result.push({
                    id: record.GatewayMAC,
                    name: record?.DeviceName
                      ? record.DeviceName
                      : "BaseStation Test",
                    email: item.Email,
                    navigate: ROUTE.BaseStation,
                    status: status,
                    location: record.GatewayLocation,
                    firmware: record.Firmware,
                    color: Color[status],
                    limit: 16,
                    navigateTo: 2,
                  });
                }
              });
            });
            accountinfo[index].children = result;
          })
        );
      }
      results[0].children = accountinfo;
    }

    return results;
  } catch (error) {
    throw new Error(error);
  }
};

export const getTreeData3API = async (dynamoDBClient, data = []) => {
  try {
    if (data.length > 0) {
      let accounts = [];
      accounts = data[0].children;
      const beaconDataParams = {
        TableName: "BeaconData",
        ProjectionExpression:
          "Email, BeaconMAC, Battery, DateUpdated, GatewayMac",
      };
      const beaconsParams = {
        TableName: "Beacons",
        ProjectionExpression:
          "BeaconName, Email, BeaconMAC, BeaconLocation, Firmware",
      };
      const snoozeParams = {
        TableName: "SnoozeSettings",
        ProjectionExpression:
          "SnoozeTimeStampEnd , SnoozeTimeStampStart, BeaconMAC",
      };
      const result1 = await dynamoDBClient.scan(beaconDataParams).promise();
      const result2 = await dynamoDBClient.scan(beaconsParams).promise();
      const result3 = await dynamoDBClient.scan(snoozeParams).promise();
      const beaconDataRecord = result1.Items;
      const beaconsRecord = result2.Items;
      const snoozeData = result3.Items;

      await Promise.all(
        accounts.map(async (item, index1) => {
          let userBaseStations = [];
          userBaseStations = item.children;
          const parent = item;
          let dummyGateway;
          // Check if there is any snooze beacon related to user
          let snoozeUserBeacons = [];
          if (snoozeData.length > 0) {
            snoozeUserBeacons = snoozeData.filter(
              (snoozeItem) => item.email === snoozeItem.Email
            );
          }
          // Check if user have Base Stations
          if (userBaseStations.length > 0) {
            // First check if all the Gateways with which beacons are associated
            // Also exits in user account

            const notPresentGatewayBeacons = beaconDataRecord.filter(
              (object) => {
                if (item.email === object.Email) {
                  return !userBaseStations.some(
                    (obj2) => obj2.id === object.GatewayMac
                  );
                }
                return false;
              }
            );
            // Check if there exist a beacon which is associated with a non existing gateway
            // In User account.
            if (notPresentGatewayBeacons.length > 0) {
              // Now create an array of all the beacons
              // Which are attached to that non existing gateway
              const arr = notPresentGatewayBeacons.reduce((acc, item) => {
                const beaconFound = beaconsRecord.filter(
                  (item2) => item2.BeaconMAC === item.BeaconMAC
                );
                if (beaconFound.length > 0) {
                  acc.push({
                    id: beaconFound[0].BeaconMAC,
                    name: beaconFound[0].BeaconName
                      ? beaconFound[0].BeaconName
                      : "Beacon Test",
                    email: beaconFound[0].Email,
                    navigate: ROUTE.Beacon,
                    status: "offline",
                    location: beaconFound[0].BeaconLocation,
                    batteryLevel: "Not Available",
                    firmware: "Not Available",
                    macNumber: "Not Available",
                    color: "#FFFFFF",
                    limit: 14,
                    navigateTo: 3,
                  });
                }
                return acc;
              }, []);
              // Add a Dummy gateway

              if (arr.length > 0) {
                dummyGateway = {
                  id: `${parent.email}DummyBS1`,
                  name: "--N/A--",
                  email: "ocufii@beacons.com",
                  navigate: "",
                  status: "offline",
                  location: "xxxx",
                  firmware: "xxxx",
                  color: Color["offline"],
                  limit: 16,
                  navigateTo: 5,
                  children: arr,
                };
              }
            }

            // Now handle beacons Who are present in Beacon table but not in beaconData table
            // check if there are such beacons
            const notPresentBeacons = beaconsRecord.reduce((acc, object) => {
              if (object.Email === item.email) {
                const check = beaconDataRecord.some(
                  (obj2) => obj2.BeaconMAC === object.BeaconMAC
                );
                if (!check) {
                  acc.push({
                    id: object.BeaconMAC,
                    name: object.BeaconName ? object.BeaconName : "Beacon Test",
                    email: object.email,
                    navigate: ROUTE.Beacon,
                    status: "offline",
                    location: object.BeaconLocation,
                    batteryLevel: "Not Available",
                    firmware: object.Firmware,
                    macNumber: "Not Available",
                    color: "#FFFFFF",
                    limit: 14,
                    navigateTo: 3,
                  });
                }
              }
              return acc;
            }, []);

            await Promise.all(
              userBaseStations.map(async (userBS, index2) => {
                const result = [];
                beaconDataRecord.forEach((beacon2) => {
                  if (beacon2.Email === item.email) {
                    let status;
                    if (snoozeUserBeacons.length > 0) {
                      const snoozeStatus = snoozeUserBeacons.filter(
                        (sbeacon) => sbeacon.BeaconMAC === beacon2.BeaconMAC
                      );
                      if (snoozeStatus.length > 0) {
                        const snooze = snoozeStatus[0];
                        const now = moment()
                          .utc()
                          .format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
                        const isBetween = moment(now).isBetween(
                          snooze.SnoozeTimeStampStart,
                          snooze.SnoozeTimeStampEnd
                        );
                        const isGreaterTime = checkStatusExpiry(
                          beacon2.DateUpdated
                        );
                        if (isGreaterTime) {
                          status = "offline";
                        } else if (isBetween) {
                          status = "snoozed";
                        } else {
                          status = "online";
                        }
                      } else {
                        const isGreaterTime = checkStatusExpiry(
                          beacon2.DateUpdated
                        );

                        if (isGreaterTime) {
                          status = "offline";
                        } else {
                          status = "online";
                        }
                      }
                    } else {
                      const isGreaterTime = checkStatusExpiry(
                        beacon2.DateUpdated
                      );

                      if (isGreaterTime) {
                        status = "offline";
                      } else {
                        status = "online";
                      }
                    }
                    beaconsRecord?.forEach((record) => {
                      if (
                        beacon2.BeaconMAC === record.BeaconMAC &&
                        beacon2.GatewayMac === userBS.id &&
                        userBS.email === beacon2.Email &&
                        userBS.email === record.Email
                      ) {
                        result.push({
                          id: beacon2?.BeaconMAC,
                          name: record?.BeaconName
                            ? record.BeaconName
                            : "Beacon Test",
                          email: record?.Email,
                          navigate: ROUTE.Beacon,
                          status: status,
                          location: record.BeaconLocation,
                          batteryLevel: beacon2.Battery,
                          firmware: record.Firmware,
                          macNumber: record.GatewayMAC,
                          color: Color[status],
                          limit: 14,
                          navigateTo: 3,
                        });
                      }
                    });
                  }
                });
                // Now insert the beacons with no beacon data in user base station
                // only if the user base station is at index 0
                if (index2 === 0) {
                  if (notPresentBeacons.length > 0) {
                    data[0].children[index1].children[index2].children = [
                      ...notPresentBeacons,
                      ...result,
                    ];
                  } else {
                    data[0].children[index1].children[index2].children = result;
                  }
                } else if (userBS.name !== "--N/A--") {
                  data[0].children[index1].children[index2].children = result;
                }
              })
            );

            if (notPresentGatewayBeacons.length > 0) {
              if (dummyGateway != null) {
                data[0].children[index1].children.push(dummyGateway);
              }
            }
          } else {
            // If user does not have any base station
            // Create a temporary base with Name: ---N/A--
            // And assign all the beacons to it.
            // First get all the beacons related to user
            const beacontempGateway = beaconsRecord.filter(
              (item) => item.Email === parent.email
            );

            if (beacontempGateway.length > 0) {
              // Create temp gateway
              data[0].children[index1].children[0] = {
                id: `${parent.email}DummyBS1`,
                name: "--N/A--",
                email: "ocufii@beacons.com",
                navigate: "",
                status: "offline",
                location: "xxxx",
                firmware: "xxxx",
                color: Color["offline"],
                limit: 16,
                navigateTo: 5,
              };
              // put all the beacons inside.
              const arr = beacontempGateway.map((item) => {
                return {
                  id: item.BeaconMAC,
                  name: item.BeaconName ? item.BeaconName : "Beacon Test",
                  email: item.Email,
                  navigate: ROUTE.Beacon,
                  status: "offline",
                  location: item.BeaconLocation,
                  batteryLevel: "Not Available",
                  firmware: "Not Available",
                  macNumber: "Not Available",
                  color: "#FFFFFF",
                  limit: 14,
                  navigateTo: 3,
                };
              });
              data[0].children[index1].children[0].children = arr;
            }
          }
        })
      );
    }

    return data;
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};

export const RefreshTokenAPI = async (token) => {
  try {
    var response = await api.post(`${Controller.dynamoDB}/RefreshToken`, {
      token: token,
    });
    const refreshToken = response.data.access_token;
    const status = response.data.status;
    if (status === 201) {
      return refreshToken;
    }

    return "";
  } catch (error) {
    throw new Error(error);
  }
};
